import { render, staticRenderFns } from "./CRUDCercas.vue?vue&type=template&id=0bb3b451&"
import script from "./CRUDCercas.vue?vue&type=script&lang=js&"
export * from "./CRUDCercas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports